import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import 'rxjs/Rx';
import {Observable} from 'rxjs/Observable';

import {GlobalVariable} from '../../global';

import {
RequestParameters
} from '../../shared/models/request-parameters/parameter.model';
import {City} from './city.model';
import {Subject} from 'rxjs/Subject';

@Injectable()

export class CityService {
  private subject = new Subject<any>();
  constructor(private http: HttpClient) {
  }

  getCities (parameters: RequestParameters = new RequestParameters()) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/cities', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
      (error: HttpErrorResponse) => {
        return Observable.throw({
          code: error.status,
          content: JSON.parse(error.error).message
        });
      }
    );

  }

  postCity (city: City) {

    const body = Object.assign({}, city);
    delete body.reference;
    body.state = city.state.reference;

    return this.http.post(GlobalVariable.BASE_API_URL + '/cities', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  putCity (city: City) {

    const body = Object.assign({}, city);
    delete body.reference;
    body.state = city.state.reference;
    return this.http.put(GlobalVariable.BASE_API_URL + '/city/' + city.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  deleteCity (city: City) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/city/' + city.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }
  emitMessage(msg: object) {
    this.subject.next(msg);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/parameters/cities/city.service.ts